/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:6b3615c2-a0d9-4577-a756-862035a2243a",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_J5kZYZH7Q",
    "aws_user_pools_web_client_id": "1hf1ho9d90ptgksa5tpkldrm06",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_cloud_logic_custom": [
        {
            "name": "RestApi",
            "endpoint": "https://ctqysft3ek.execute-api.eu-west-2.amazonaws.com/tasks",
            "region": "eu-west-2"
        }
    ]
};


export default awsmobile;
